import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventsListComponent } from './events-list/events-list.component';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { SharedModule } from '../shared/shared.module';
import { Drawer } from "primeng/drawer";
import { Select } from "primeng/select";

@NgModule({
  declarations: [
    EventsListComponent
  ],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgCircleProgressModule.forRoot({
        radius: 15,
        outerStrokeWidth: 3,
        innerStrokeWidth: 1,
        outerStrokeColor: "#4882c2",
        innerStrokeColor: "#e7e8ea",
        animationDuration: 300,
        showSubtitle: false,
        showUnits: false,
        showBackground: false,
        startFromZero: false,
    }),
    Drawer,
    Select
]
})
export class EventsModule { }
